export default function Pill({ children, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={
        "px-3 py-1.5 rounded-full text-sm ring-1 transition " +
        (active
          ? "bg-zinc-900 text-white ring-zinc-900 dark:bg-white dark:text-zinc-900 dark:ring-white"
          : "bg-white/70 dark:bg-zinc-900/50 text-zinc-700 dark:text-zinc-200 ring-black/10 dark:ring-white/10 hover:bg-white")
      }
    >
      {children}
    </button>
  );
}
